export default [
    {
        path: "/parts",
        name: "parts",
        component: () => import("@/views/modules/parts/list"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Parts List",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Parts" },
            ],
        },
        children: [
            {
                path: "/parts/create",
                name: "parts-create",
                component: () => import("@/views/modules/parts/create"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Part Create",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: "Parts", link: "/parts" },
                        { text: "Create" },
                    ],
                },
            },
            {
                path: "/parts/:id/edit",
                props: true,
                name: "parts-edit",
                component: () => import("@/views/modules/parts/edit"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Part Edit",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        {
                            text: "Part",
                            to: { name: "parts-show" },
                            param: "id",
                        },
                        { text: "Edit" },
                    ],
                },
            },
            {
                path: "/parts/:id/show",
                props: true,
                name: "parts-show",
                component: () => import("@/views/modules/parts/show"),
                meta: {
                    sidebarToggle: true,
                    requiresAuth: true,
                    layout: "app",
                    title: "Part Details",
                    breadcrumb: [
                        { text: "Home", to: { name: "home" } },
                        { text: "Parts", to: { name: "parts" } },
                        { text: "Details" },
                    ],
                },
            },
        ],
    },
    {
        path: "/parts-adjustments",
        name: "parts-adjustments",
        component: () => import("@/views/modules/parts/adjustments"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Parts Adjustments",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Parts Adjustments" },
            ],
        },
    },

    {
        path: "/parts-requisitions-list",
        name: "parts-requisitions-list",
        component: () => import("@/views/modules/parts/requisitionsList"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Requisition List",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Requisition List" },
            ],
        },
    },

    {
        path: "/parts-returns-list",
        name: "parts-returns-list",
        component: () => import("@/views/modules/parts/returnsList"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Returns List",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Returns List" },
            ],
        },
    },
    {
        path: "/parts-upload",
        name: "parts-upload",
        component: () => import("@/views/modules/parts/upload"),
        meta: {
            requiresAuth: true,
            layout: "app",
            title: "Parts Upload",
            breadcrumb: [
                { text: "Home", to: { name: "home" } },
                { text: "Parts Upload" },
            ],
        },
    }
];
